export const iconFontAwesomeCampingFire = (
	<i className="fa-solid fa-fire"></i>
);
